import React from "react";

const BasicLayout = ({ children }) => {
  return (
    <div className="xl:max-w-[1180px] max-w-[980px] flex m-auto px-2">
      <div className="flex-1">{children}</div>
    </div>
  );
};

export default BasicLayout;
